import React, { PureComponent } from 'react';
import memoize from 'memoize-one';

import styled from 'styled-components';

import TabComponent from './tab-component';
import Teachers from './teachers';
import Applicants from './applicants';
import StudentDemos from './student-demos';
import PaymentLinks from './payment-links';
import TrainingAccounts from './training-accounts';
import TeacherClassrooms from './teacher-classrooms';
import ParentRelationshipManagers from './parent-relationship-managers';
import CSM from './csm';

const Container = styled.div`
  width: inherit;
  height: inherit;
  margin: 0 auto;
`;

const TABS = [
  {
    id: 'teachers',
    label: 'Teachers',
    Component: Teachers,
  },
  {
    id: 'teacher-applicants',
    label: 'Teachers Applicants',
    Component: Applicants,
  },
  {
    id: 'studentdemos',
    label: 'Student Demos',
    Component: StudentDemos,
  },
  {
    id: 'payments',
    label: 'Payments Link',
    Component: PaymentLinks,
  },
  {
    id: 'training-accounts',
    label: 'Training Accounts',
    Component: TrainingAccounts,
  },
  {
    id: 'teacher-classrooms',
    label: 'Teacher Classrooms',
    Component: TeacherClassrooms,
  },
  {
    id: 'parent-relationship-managers',
    label: 'RM Portal',
    Component: ParentRelationshipManagers,
  },
  {
    id: 'csm',
    label: 'Customer Success Managers',
    Component: CSM,
  },
];

const getTabs = memoize((tabs, studentId) =>
  tabs.map(tab => ({
    ...tab,
    link: `/users/${tab.id}`,
  })),
);

export default class BatchAssignment extends PureComponent {
  render() {
    const { activeTab } = this.props;
    const tabs = getTabs(TABS);

    return (
      <Container>
        <TabComponent tabs={tabs} activeTab={activeTab} />
      </Container>
    );
  }
}

BatchAssignment.defaultProps = {
  activeTab: 'students',
};
